module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/authentication/reset-password/reset-password.component.scss
// module id = ./src/app/authentication/reset-password/reset-password.component.scss
// module chunks = main